module.exports = __webpack_public_path__ + "static/cocoa_cake_slika1-ce7ba2b16ce4e0ba61c441a855854eb8.jpg";